import * as rdfc from 'rfdc';

export function clone<T>(obj: T) {
  return rdfc({ proto: false })(obj) as T;
}
